import { render, staticRenderFns } from "./MyWalletMyNfts.vue?vue&type=template&id=94f749ee&scoped=true"
import script from "./MyWalletMyNfts.vue?vue&type=script&lang=ts"
export * from "./MyWalletMyNfts.vue?vue&type=script&lang=ts"
import style0 from "./MyWalletMyNfts.vue?vue&type=style&index=0&id=94f749ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94f749ee",
  null
  
)

export default component.exports